export function PlusSign(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_685_2031)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9216 1.04389C10.9216 0.536266 10.5101 0.124756 10.0025 0.124756C9.49487 0.124756 9.08336 0.536266 9.08336 1.04389V8.806H1.31952C0.811901 8.806 0.400391 9.21751 0.400391 9.72514C0.400391 10.2328 0.811901 10.6443 1.31952 10.6443H9.08336V18.4042C9.08336 18.9118 9.49487 19.3234 10.0025 19.3234C10.5101 19.3234 10.9216 18.9118 10.9216 18.4042V10.6443H18.6799C19.1875 10.6443 19.599 10.2328 19.599 9.72514C19.599 9.21752 19.1875 8.80601 18.6799 8.80601H10.9216V1.04389Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_685_2031">
                    <rect width="19.2" height="19.2" fill="white" transform="translate(0.400391 0.124023)" />
                </clipPath>
            </defs>
        </svg>
    );
}
